import React from 'react';
import DesignOptionFilterForm from '../DesignOptionFilterForm';
import enhance from './enhance.js';

export const RoofAndMirrorCapsOptionFilters = ({
  options,
  roofAndMirrorCapFormPlaceHolder,
  activeFilters,
  setActiveFilters,
  clearFilter,
}) => {
  return (
    <DesignOptionFilterForm
      options={options}
      placeHolder={roofAndMirrorCapFormPlaceHolder}
      filterName="roofAndMirrorCapOption"
      setActiveFilters={setActiveFilters}
      activeFilters={activeFilters}
      clearFilter={clearFilter}
    />
  );
};

export default enhance(RoofAndMirrorCapsOptionFilters);
